import { render, staticRenderFns } from "./optionsRecord.vue?vue&type=template&id=5c1b3801&scoped=true"
import script from "./optionsRecord.vue?vue&type=script&lang=js"
export * from "./optionsRecord.vue?vue&type=script&lang=js"
import style0 from "./optionsRecord.vue?vue&type=style&index=0&id=5c1b3801&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b3801",
  null
  
)

export default component.exports